window.addEventListener("DOMContentLoaded", (event) => {
  const menu_btn = document.getElementById('mm-menu-btn');
  menu_btn.addEventListener("click", function() {
    document.querySelector('.mobile-nav-drawer').classList.toggle('active');
    document.querySelector('body').classList.toggle('menu-open');
  });

  
    
    if(document.querySelectorAll('.bps-slider').length > 0){
      var bps = document.querySelector('.bps-slider');
      var flkty = new Flickity( bps, {
        // options
        cellAlign: 'left',
        contain: true,
        fade: true,
        autoPlay: 5000,
        pageDots: false,
        prevNextButtons: false,
      });   
    }

  function complementarySlider() {
      var bps = document.querySelector('.complementary-products__content');
      if( window.innerWidth < 1023){
        if(document.querySelectorAll('.complementary-products__content').length > 0){
          
          var flkty = new Flickity( bps, {
            // options
            cellAlign: 'left',
            contain: true,
            pageDots: false
          });   
        }
      }else{
        var flkty = new Flickity(bps)
        flkty.destroy();
      }
  }
  if(document.querySelectorAll('.complementary-products__content').length > 0){
    complementarySlider();

     window.addEventListener("resize", function() {
      complementarySlider();    
    });
  }
  
 
  if(document.querySelectorAll('.product').length > 0){
      var pPSlider = document.querySelector('[data-product-thumbnails-custom]');
      var flkty = new Flickity( pPSlider, {
        asNavFor: '.product .product__media',
        cellAlign: 'left',
        contain: true,
        pageDots: false
      });
      document.querySelectorAll(".product .product__media-container .product__media a").forEach(el => {
        el.addEventListener("click", function(e){
            e.preventDefault();
        })
      })
        document.querySelectorAll("[data-product-thumbnails-custom] li button").forEach(ele => {
        ele.addEventListener("click", function(e){
          var pos = e.target.closest("li").querySelector("button").getAttribute("data-position");
          document.querySelectorAll(".product .product__media-container .product__media > div").forEach(divEl => {
            if(parseInt(divEl.closest(".media-wrapper").getAttribute("data-media-position")) == parseInt(pos)){
                divEl.classList.remove("media_item_hide");
                divEl.classList.add("active-image");
            }
            else{
                divEl.classList.add("media_item_hide");
                divEl.classList.remove("active-image");
            }
          })
        })
      })
    
      function showHideAndclickImage(){
        if(window.width > 959){
          //console.log("Greater");
          document.querySelectorAll(".product .product__media-container .product__media > div").forEach(divEl => {
              divEl.classList.remove("media_item_hide");
          })
        }
        else{
          //console.log("smaller");
          document.querySelectorAll(".product .product__media-container .product__media > div").forEach(divEl => {
              divEl.classList.add("media_item_hide");
          })
        }
      }
      
      // window.addEventListener("resize", function(){
      //   showHideAndclickImage();
      //   setTimeout(function(){
      //     document.querySelector("[data-product-thumbnails-custom] li button").click();
      //   },500);
      // })
    
      window.addEventListener("load", function(){
        showHideAndclickImage();
        setTimeout(function(){
          document.querySelector("[data-product-thumbnails-custom] li button").click();
          document.querySelector(".product__media-container > div.product__media").classList.remove("media_item_hide");
        },500);
        
      })
  
  }

  
  
})